<template>
	<div :id="id" :class="className" :style="{ height:height,width:width }" />
	<!-- <div :id="id" :class="className" style="height:100%;width:100%;" /> -->
</template>

<script>
	import echarts from "echarts";
	// import resize from "./mixins/resize";
	import "echarts-wordcloud/dist/echarts-wordcloud";
	import "echarts-wordcloud/dist/echarts-wordcloud.min";

	export default {
		// mixins: [resize],
		props: {
			className: {
				type: String,
				default: "chart"
			},
			id: {
				type: String,
				default: "chart"
			},
			width: {
				type: String,
				default: "100%"
			},
			height: {
				type: String,
				default: "100%"
			},
			data: {
				type: Array,
				// default: [],
				 default: () => []
			},
			title: {
				type: String,
				default: ""
			},
			sizeRange: {
				type: Array,
				default: () => {
					[]
				}
			}
		},
		data() {
			return {
				chart: null
			};
		},
		mounted() {
			this.initChart();
		},
		beforeDestroy() {
			if (!this.chart) {
				return;
			}
			this.chart.dispose();
			this.chart = null;
		},
		computed: {
			count() {
				return this.$store.state.countNum
			}
		},
		methods: {
			initChart() {
				let sizeRange = [12, 40]
				if (this.sizeRange) {
					sizeRange = this.sizeRange
				}
				this.chart = echarts.init(document.getElementById(this.id));
				const option = {
					title: {
						text: this.title,
						x: "center"
					},
					backgroundColor: "transparent",
					 tooltip: {
					   pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
					 },
					series: [{
						type: "wordCloud",
						//用来调整词之间的距离
						//gridSize: 10,
						gridSize: 20,
						//用来调整字的大小范围
						// Text size range which the value in data will be mapped to.
						// Default to have minimum 12px and maximum 60px size.
						sizeRange: sizeRange,
						//sizeRange: this.sizeRange ===[] ? [12,40]:this.sizeRange,
						// Text rotation range and step in degree. Text will be rotated randomly in range [-90,                                                                             90] by rotationStep 45
						//用来调整词的旋转方向，，[0,0]--代表着没有角度，也就是词为水平方向，需要设置角度参考注释内容
						// rotationRange: [-45, 0, 45, 90],
						// rotationRange: [ 0,90],
						rotationRange: [0, 30, 60, 45],
						//随机生成字体颜色
						// maskImage: maskImage,
						textStyle: {
							normal: {
								color: function() {
									 var colors = ['#c981dd',
											'#33dfd8',
											'#98ffe3',
											'#ebc4fd',
											'#fa7ca3',
											'#9bea7d',
											'#ff806b',
											'#fff006',
											'#ffe3ee',
											'#5aaaff',
											'#47d1de',
											'#88e5c9',
											'#ffd6bf',
											'#ffe168',
											'#ff806b',
											'#adb1f2',
											];
									 return colors[parseInt(Math.random() * 16)];
									// return (
									// 	"rgb(" +
									// 	Math.round(Math.random() * 255) +
									// 	", " +
									// 	Math.round(Math.random() * 255) +
									// 	", " +
									// 	Math.round(Math.random() * 255) +
									// 	")"
									// );
								}
							}
						},
						//位置相关设置
						// Folllowing left/top/width/height/right/bottom are used for positioning the word cloud
						// Default to be put in the center and has 75% x 80% size.
						left: "center",
						top: "center",
						right: null,
						bottom: null,
						width: "99%",
						height: "99%",
						//数据
						data: this.data
					}]
				};
				this.chart.setOption(option,true);
				window.addEventListener("resize", () => {
					if (this.chart) {
						//this.resizeW()
						this.chart.resize()
					}
				});
			},
			resizeW() {
				this.chart.resize()
			}
		},
		watch: {
			count: {
				handler: function(val, oldval) {
					if (val) {
						this.resizeW()
					}
				},
				deep: true //对象内部的属性监听，也叫深度监听
			}
		},
	};
</script>

<style scoped>
	.chartsClass {
		padding-left: 1.2rem;
	}
</style>
